// 下单流程临时状态（跨页面传递）
const state = {
  createOrderParams: null  // 下单页暂存参数
}

const mutations = {
  SET_ORDER_PARAMS(state, params) {
    state.createOrderParams = params
  },
  CLEAR_ORDER_PARAMS(state) {
    state.createOrderParams = null
  }
}

const actions = {
  setOrderParams({ commit }, params) {
    commit('SET_ORDER_PARAMS', params)
  },
  clearOrderParams({ commit }) {
    commit('CLEAR_ORDER_PARAMS')
  }
}

export default { namespaced: true, state, mutations, actions }

